import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const MAX_ENERGY = 10;
function useCountdown(target) {
    const [text, setText] = useState(null);
    useEffect(() => {
        if (!target) {
            setText(null);
            return;
        }
        function tick() {
            const diff = new Date(target).getTime() - Date.now();
            if (diff <= 0) {
                setText(null);
                return;
            }
            const m = Math.floor(diff / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            setText(`${m}:${String(s).padStart(2, "0")}`);
        }
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [target]);
    return text;
}
export function EnergyBar({ energy, nextEnergyAt }) {
    const countdown = useCountdown(energy < MAX_ENERGY ? nextEnergyAt : null);
    return (_jsxs("div", { children: [_jsxs("div", { style: { display: "flex", gap: 4, alignItems: "center" }, children: [Array.from({ length: MAX_ENERGY }, (_, i) => (_jsx("div", { style: {
                            width: 18,
                            height: 8,
                            borderRadius: 2,
                            background: i < energy ? "#22d3ee" : "#1e293b",
                            transition: "background 0.2s",
                        } }, i))), _jsxs("span", { style: { color: "#64748b", fontSize: 11, marginLeft: 4 }, children: [energy, "/", MAX_ENERGY] })] }), countdown && (_jsxs("div", { style: { color: "#334155", fontSize: 10, marginTop: 4 }, children: ["+1 \u0447\u0435\u0440\u0435\u0437 ", countdown] }))] }));
}
